<template>
    <div class="page_container">
        <div class="page_header">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/product_management' }">产品管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card class="page_card" v-loading="loading">
            <div class="flex_js_wrap">
              <div class="table_container">
                <el-form class="search_form" size="small" @submit.native.prevent :inline="true">
                  <el-form-item label="关键词">
                    <el-input
                      class="keyword_input"
                      v-model="searchForm.keyword"
                      placeholder="激活码、硬件ID、备注"
                      @clear="handleClickSearch"
                      @keyup.enter.native="handleClickSearch"
                      clearable>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="操作记录">
                    <el-input
                      class="operation_record_input"
                      v-model.trim="searchForm.operationRecord"
                      placeholder="请输入激活码或硬件ID"
                      maxlength="128"
                      @clear="handleClickSearch"
                      @keyup.enter.native="handleClickSearch"
                      clearable>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="search_actions">
                    <el-button type="primary" icon="el-icon-search" @click="handleClickSearch">搜索</el-button>
                    <el-button icon="el-icon-refresh" @click="handleClickReset">重置</el-button>
                  </el-form-item>
                </el-form>
                <el-table :data="tableData"  style="width: 100%" :height="tableHeight" >
                  <el-table-column   prop="id"  align="center"  label="序号"  width="80"></el-table-column>
                  <el-table-column   prop="product_name"  align="center"  label="产品名称"  min-width="140">
                    <template slot-scope="{row}">
                      <span class="template_color" @click="handleClickDetail(row)" v-text="row.product ? row.product.product_name : ''"></span>
                    </template>
                  </el-table-column>
                  <el-table-column   prop="license_code"  align="center"  label="激活码"  min-width="265">
                    <template slot-scope="{row}">
                      <span class="tableLicenseCodeColumn" v-text="row.license_code"></span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="machine_id" align="center" label="硬件ID" min-width="120" show-overflow-tooltip>
<!--                    <template slot-scope="{row}">-->
<!--                      <el-tooltip class="item" effect="dark" :content="row.machine_id.toUpperCase()" placement="top">-->
<!--                        <span   v-text="formatString(row.machine_id)"></span>-->
<!--                      </el-tooltip>-->
<!--                    </template>-->
                  </el-table-column>
                  <el-table-column   prop="machine_id"  align="center"  label="当前状态"  min-width="120">
                    <template slot-scope="{row}">
                      <span v-if="!row.machine_id">未激活</span>
                      <span v-else v-text="timeWarFunction(row.client_end_date ? row.client_end_date : row.end_date) ? '已过期' : '已激活'"></span>

                    </template>
                  </el-table-column>
                  <el-table-column   prop="date"  align="center"  label="授权日期"  min-width="320">
                    <template slot-scope="{row}">
                        <span v-if="row.start_date" v-text="convertToCurrentTimezone(row.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(row.end_date,'/','datetime')"></span>
                    </template>
                  </el-table-column>

                  <el-table-column   prop="date"  align="center"  label="软件到期时间"  min-width="160">
                    <template slot-scope="{row}">
                        <span v-if="row.client_end_date" v-text="convertToCurrentTimezone(row.client_end_date,'/','datetime')"></span>
                    </template>
                  </el-table-column>
                  <el-table-column   prop="last_connection_time"  align="center"  label="上次连接时间"  min-width="160" show-overflow-tooltip	>
                    <template slot-scope="{row}">
                      <span v-if="row.last_connection_time" v-text="convertToCurrentTimezone(row.last_connection_time,'/','datetime')"></span>
                    </template>
                  </el-table-column>
                  <el-table-column   prop="date"  align="center"  label="备注"  min-width="220" show-overflow-tooltip	>
                    <template slot-scope="{row}">
                      <span v-text="row.note"></span>
                    </template>
                  </el-table-column>
                  <el-table-column   prop="date"  align="center"  label="操作" width="140" fixed="right">
                    <template slot-scope="{row}">
                      <div class="ta-r">
                        <el-button v-if="!row.license_code" size="mini" type="text" @click="handleClickGenerateAuthCode(row)">生成激活码</el-button>
                        <span v-if="!row.license_code" class="el-table-column-line"></span>
<!--                        如果有激活码并且没有被激活  ||  有激活码被激活了并且授权结束日期超过了当前日期 || 有激活码被激活了并且最后一次连接时间加提醒时间 小于 今天-->

<!--                        用户端可回收逻辑:-->
<!--                        1: 如果有激活码并且没有被激活-->
<!--                        2: 当前日期 大于 授权结束日期(有激活码被激活了)-->
<!--                        3: 当前日期 大于 最后一次连接时间加提醒时间 (有激活码被激活了)(离线时间需大于0,否则禁止回收)-->
<!--                        4: 永久授权需联系管理员回收-->
                        <el-button v-if="(!row.machine_id && row.license_code) || (row.machine_id && row.license_code && timeWarFunction(row.client_end_date ? row.client_end_date : row.end_date)) || (row.machine_id && row.license_code && lastConnectionTimeWarMaxFfflineTime(row))" size="mini" type="text" @click="handleClickRetrieveAuthCode(row)">回收激活码</el-button>
                        <span v-if="(!row.machine_id && row.license_code) || (row.machine_id && row.license_code && timeWarFunction(row.client_end_date ? row.client_end_date : row.end_date))|| (row.machine_id && row.license_code && lastConnectionTimeWarMaxFfflineTime(row))"  class="el-table-column-line"></span>
                        <el-dropdown trigger="click" class="dropdown_more" >
                          <i class="el-icon-more"></i>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleClickDetail(row)" >详情</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickNote(row)" >备注</el-dropdown-item>
                            <el-dropdown-item  v-if="row.start_date" @click.native="handleClickEditAuthDate(row)" >编辑</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickLog(row)" >操作记录</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </template>
                  </el-table-column>

                </el-table>

                <el-pagination background
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="pagination.pageNum"
                               :page-sizes="pagination.pageSizes"
                               :page-size="pagination.pageSize"
                               :layout="pagination.layout"
                               :total="pagination.total">
                </el-pagination>

              </div>



            </div>

        </el-card>
      <generateAuthCode :generateAuthCodeVisible.sync="generateAuthCodeVisible" v-if="generateAuthCodeVisible" :licenseId="licenseId" :productName="productName" :generateAuthData="generateAuthData"  @success="generateAuthCodeSuccess"/>
      <copyAuthCode :copyAuthCodeVisible.sync="copyAuthCodeVisible" v-if="copyAuthCodeVisible" :licenseCode="licenseCode" :productName="productName"  @success="handleClickSearch"/>
      <retrieveAuthCode :retrieveAuthCodeVisible.sync="retrieveAuthCodeVisible" v-if="retrieveAuthCodeVisible" :retrieveInfo="retrieveInfo"   @success="handleClickSearch"/>
      <productDetail :productDetailVisible.sync="productDetailVisible" v-if="productDetailVisible" :productId="productId"  />
      <productLog :logVisible.sync="logVisible" v-if="logVisible" :productName="productName" :logId="logId"  />
      <productNote :noteVisible.sync="noteVisible" v-if="noteVisible" :noteText="noteText"  :productId="productId"  @success="handleClickSearch"/>
      <productEditAuthDate :productEditVisible.sync="productEditVisible" :noteText="noteText"  v-if="productEditVisible" :productId="productId" :generateAuthData="generateAuthData"  @success="handleClickSearch"/>


    </div>
</template>

<script>
import {productList ,productLicenseLogs} from '@/api/api'
import {getTableHeight,convertToCurrentTimezone} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";
import generateAuthCode from './generate_auth_code.vue'
import copyAuthCode from './copy_auth_code.vue'
import retrieveAuthCode from './retrieve_auth_code.vue'
import productDetail from './product_detail.vue'
import productLog from './product_log.vue'
import productNote from './product_note.vue'
import productEditAuthDate from './product_edit_auth_date.vue'
export default {
    name: 'product_management',
    components: {
      generateAuthCode,
      copyAuthCode,
      retrieveAuthCode,
      productDetail,
      productLog,
      productNote,
      productEditAuthDate
    },
    data() {
        return {
          loading:false,
          tableHeight:'',
          tableData:[],
          searchForm:{
            keyword:'',
            operationRecord:''
          },
          generateAuthCodeVisible:false,
          licenseId:0,
          productName:'',
          copyAuthCodeVisible:false,
          licenseCode:'',
          retrieveAuthCodeVisible:false,
          retrieveInfo:{},

          productDetailVisible:false,
          productId:0,

          logId:0,
          logsList:[],
          logVisible:false,
          noteVisible:false,
          noteText:'',
          generateAuthData:null,
          productEditVisible:false,

        }
    },
  mixins: [pagination],
  created() {
    //将计算的table高度赋值给table
    this.tableHeight = getTableHeight(265)

  },
    mounted() {
      // if(!this.webUserInfo || !this.webUserInfo.id){
      //   localStorage.removeItem('vuex')
      //   this.$router.replace('/')
      // }
      this.getTableData()
      //窗口缩放时动态修改table的高度
      window.onresize = () => {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer)
        }
        //开启定时器，节流函数
        this.resizeTimer = setTimeout(() => {
          //将计算的table高度赋值给table
          this.tableHeight = getTableHeight(215)
          //清除定时器
          this.resizeTimer = null
        }, 100)
      }

    },
    computed: {
      ...mapState(['webUserInfo']),
    },
    methods: {
      formatString(str) {
        // 处理空字符串或长度不足的情况
        if (!str || str.length <= 8) {
          return str.toUpperCase();
        }
        // 提取前4位并大写
        const firstPart = str.slice(0, 4).toUpperCase();
        // 提取后4位并大写
        const lastPart = str.slice(-4).toUpperCase();
        // 拼接结果
        return `${firstPart}****${lastPart}`;
      },
      convertToCurrentTimezone(utcTime,separator,type) {
        return convertToCurrentTimezone(utcTime,separator,type);
      },
      // 当前日期和授权结束日期比
      timeWarFunction(time){
        let rowTime =  this.convertToCurrentTimezone(time,'/','datetime')
        let currentTime = this.getCurrentDate()
        const date1 = new Date(rowTime);
        const date2 = new Date(currentTime);
        if(date1 < date2){
          return true
        }else{
          return  false
        }
      },
      // 最后一次连接时间 + 无需在线校验小于当前时间 则显示回收按钮
      lastConnectionTimeWarMaxFfflineTime(row){
        if(!row.last_connection_time){
          return  false
        }
        let lastConnectionTime =  this.convertToCurrentTimezone(row.last_connection_time,'/','datetime') //最后一次连接时间
        let max_offline_time = (row.offline_time && row.offline_time.value_code)? row.offline_time.value_code : 0
        // 0 ==永久

        if(max_offline_time == 0){
          return false
        }else{
          let max_time = this.addDaysToDate(lastConnectionTime,max_offline_time ? Number(max_offline_time) : 0)
          let currentTime = this.getCurrentDate()
          const date1 = new Date(max_time);
          const date2 = new Date(currentTime); //今天
          if(date1 < date2){
            return true
          }else{
            return  false
          }
        }

      },
      addDaysToDate(dateStr, days) {
        // 将日期字符串转换为Date对象
        const date = new Date(dateStr);
        // 给日期加上天数
        date.setDate(date.getDate() + days);
        // 将Date对象转换回字符串
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        // 将单个数字格式化为两位数
        const formatNumber = (num) => num < 10 ? '0' + num : num;

        // 组合成指定格式的字符串
        return `${year}/${formatNumber(month)}/${formatNumber(day)} ${formatNumber(hours)}:${formatNumber(minutes)}`;
      },
      getCurrentDate() {
        const now = new Date();
        const year = now.getFullYear(); // 获取年份
        const month = now.getMonth() + 1; // 获取月份，月份从0开始，所以需要+1
        const day = now.getDate(); // 获取日期
        const hours = now.getHours(); // 获取小时
        const minutes = now.getMinutes(); // 获取分钟

        // 将单个数字格式化为两位数（例如，1 -> 01）
        const formatNumber = (num) => num < 10 ? '0' + num : num;

        // 组合成指定格式的字符串
        return `${year}/${formatNumber(month)}/${formatNumber(day)} ${formatNumber(hours)}:${formatNumber(minutes)}`;
      },

      handleClickLog(row){
        this.productName = row.product ? row.product.product_name : ''
        this.logId = row.id
        this.logVisible = true
      },
      handleClickDetail(row){
        this.productId = row.id
        this.productDetailVisible = true
      },
      handleClickNote(row){
        this.productId = row.id
        this.noteText = row.note
        this.noteVisible = true
      },
      handleClickEditAuthDate(row){
        this.productId = row.id
        this.noteText = row.note
        let is_activation = !row.machine_id ? '未激活' :this.timeWarFunction(row.client_end_date ? row.client_end_date : row.end_date) ?  '已过期' : '已激活'
        this.generateAuthData = {
          license_module_id:row.offline_time?.id,
          value_code:row.offline_time?.value_code,
          is_activation:is_activation
        }
        this.productEditVisible = true
      },
      // 生成激活码
      handleClickGenerateAuthCode(row){
        this.licenseId = row.id
        this.generateAuthData = {
          license_module_id:row.offline_time?.id,
          value_code:row.offline_time?.value_code,
        }
        this.productName = row.product.product_name
        this.generateAuthCodeVisible = true
      },
      // 生成激活码之后的回调
      generateAuthCodeSuccess(data){
        this.productName = data.product_name
        this.licenseCode = data.license_code
        this.copyAuthCodeVisible = true
      },
      // 回收激活码
      handleClickRetrieveAuthCode(row){
        this.retrieveInfo = {
          license_id:row.id,
          license_code:row.license_code,
          product_name:row.product_name,
          end_date:row.end_date,
          client_end_date:row.client_end_date,
          status_text:!row.machine_id ? '未激活' :this.timeWarFunction(row.client_end_date ? row.client_end_date : row.end_date) ?  '已过期' : '已激活'
        }
        this.retrieveAuthCodeVisible = true
      },

      // 复制
      handleClickCopy(value){
        const textToCopy = value;
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        // 选中文本并复制
        textarea.select();
        document.execCommand('copy');
        // 移除临时元素
        document.body.removeChild(textarea);
        this.$message({
          showClose: true,
          message: '复制成功',
          type: 'success',
          duration: 1500,
          onClose: () => { }
        });
      },

      // 筛选
      handleClickSearch(){
        this.pagination.pageNum = 1
        this.getTableData()
      },
      //重置列表
      handleClickReset() {
        this.pagination.pageNum = 1
        this.searchForm = this.$options.data().searchForm
        this.getTableData()
      },
      // 获取数据列表
      getTableData(){
        this.loading = true
        let postData = {
          page: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          keyword:this.searchForm.keyword,
          operation_record:this.searchForm.operationRecord
        }
        productList(postData).then(res => {
          if (res.code === 200) {
            let {total, data} = res.data
            this.tableData = data
            this.pagination.total = total
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      handleSizeChange(val) {
        this.pagination.pageNum = 1
        this.pagination.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.pagination.pageNum = val
        this.getTableData()
      },

    },
    watch: {

    },
}
</script>

<style scoped lang="scss">
.search_form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 8px;
}
.keyword_input {
  width: 280px;
}
.operation_record_input {
  width: 280px;
}
.search_actions {
  white-space: nowrap;
}
.tableLicenseCodeColumn{
  font-family: fangsong;
  color: #1c2127;
  font-size: 15px;
}
.dropdown_more{
  cursor: pointer;
}

.el-icon-more{
  transform: rotate(90deg);
  cursor: pointer;
  vertical-align: middle;
}
.el-icon-more:hover{
  color: #1990ff;
}
.template_color{
  cursor: pointer;
}
.page_container .page_card {
    overflow-y: scroll;
    padding-bottom: 20px;

  .table_container{
    width:100%
  }
  .detail_container{
    min-width: 340px;
    width: 310px;
    background: rgba(250, 250, 250, 1);
    padding: 16px;
    box-sizing: border-box;
    .detail_title{
      line-height: 24px;
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
    }
    ul{
      width: 100%;
      li{
        width: 100%;
        border-bottom:  1px solid rgba(217, 217, 217, 1);
        padding-bottom: 12px;
        &:last-child{
          border-bottom: 0;
        }
        .top{
          padding:7px 0;
          padding-right: 40px;
          box-sizing: border-box;
          position: relative;
          div{
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
            font-weight: bold;
            font-size: 12px;
            p{
              color: rgba(51, 51, 51, 1);
              line-height: 22px;
              margin-left: 14px;
              display: inline-block;
            }
          }
          span{
            position: absolute;
            right: 0;
            top: 7px;
            line-height: 22px;
            cursor: pointer;
          }
        }

        .bottom{
          width: 100%;
          display: flex;
          justify-content: space-between;

          .left{
            width: 82px;
            padding-right: 8px;
            box-sizing: border-box;
            p{
              line-height: 22px;
              color: rgba(51, 51, 51, 1);
              margin-bottom: 3px;
            }
          }
          .right{
            width: calc(100% - 82px);

            .field_list{
              margin-bottom: 4px;
              line-height: 22px;
              display: flex;
              justify-content: space-between;
              color: rgba(102, 102, 102, 1);
              font-size: 14px;
              .field_name{
                width: 70px;
              }
              .field_value{
                width: calc(100% - 70px);

                span{
                  float: right;
                }
              }
            }
          }
        }

      }
    }
  }
}

</style>
